import { ERoles } from "@/data/roles";

export function getHumanReadableRole(roleName?: string | null): string {
  if (!roleName) return "Unknown Role";

  const normalized = roleName.trim().toLowerCase();

  switch (normalized) {
    case ERoles.OrganizationUser.toLowerCase():
    case ERoles.User.toLowerCase():
      return "User";
    case ERoles.OrganizationAdmin.toLowerCase():
    case ERoles.Admin.toLowerCase():
      return "Admin";
    case ERoles.SuperAdmin.toLowerCase():
      return "Super Admin";
    default:
      // Fallback for roles that might be added later but not mapped
      return roleName;
  }
}
